import { render, staticRenderFns } from "./GroupButtons.vue?vue&type=template&id=13d1fe4c&scoped=true&"
import script from "./GroupButtons.vue?vue&type=script&lang=js&"
export * from "./GroupButtons.vue?vue&type=script&lang=js&"
import style0 from "./GroupButtons.vue?vue&type=style&index=0&id=13d1fe4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d1fe4c",
  null
  
)

export default component.exports